module.exports = __webpack_public_path__ + "static/img/upper-level.b1817e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/upper-level.png
// module id = ndVP
// module chunks = 0